import { ConnFeatureFilter, CDIFilterState, MemberModel, PopularityFilters, SortOption } from "../types/CDIFilter";

export interface LastSearchFilter extends CDIFilterState {
	selectedMember: MemberModel;
}

export interface LastFeatureFilter {
	featureFilter: ConnFeatureFilter[];
}

export interface LastConnectorFilter {
	connectorFilter: ConnFeatureFilter[];
}

export interface LastPopularityFilter {
	popularityFilter: PopularityFilters;
}

const designItemSearchFilterKey = "designItemSearchFilter";
const designItemFeatureFilterKey = "designItemFeatureFilter";
const designItemConnectorFilterKey = "designItemConnectorFilter";
const designItemPopularityFilterKey = "designItemPopularityFilter";
const designItemSortKey = "designItemSortPreference";

export const setLastDesignItemSearchFilter = (designItemSearchFilter: LastSearchFilter) => {
	localStorage.setItem(designItemSearchFilterKey, JSON.stringify(designItemSearchFilter));
};

export const setLastDesignItemFeatureFilter = (designItemFeatureFilter: LastFeatureFilter) => {
	localStorage.setItem(designItemFeatureFilterKey, JSON.stringify(designItemFeatureFilter));
};

export const setLastDesignItemConnectorFilter = (designItemConnectorFilter: LastConnectorFilter) => {
	localStorage.setItem(designItemConnectorFilterKey, JSON.stringify(designItemConnectorFilter));
};

export const setLastDesignItemPopularityFilter = (designItemPopularityFilter: LastPopularityFilter) => {
	localStorage.setItem(designItemPopularityFilterKey, JSON.stringify(designItemPopularityFilter));
};

export const setLastDesignItemSortPreference = (designItemSortPreference: SortOption) => {
	localStorage.setItem(designItemSortKey, JSON.stringify(designItemSortPreference));
};

export const getLastDesignItemSearchFilter = (): LastSearchFilter | null => {
	const result = localStorage.getItem(designItemSearchFilterKey);
	if (result !== null) {
		return JSON.parse(result);
	}
	return null;
};

export const getLastDesignItemFeatureFilter = (): LastFeatureFilter | null => {
	const result = localStorage.getItem(designItemFeatureFilterKey);
	return result === null ? null : JSON.parse(result);
};

export const getLastDesignItemConnectorFilter = (): LastConnectorFilter | null => {
	const result = localStorage.getItem(designItemConnectorFilterKey);
	return result === null ? null : JSON.parse(result);
};

export const getLastDesignItemPopularityFilter = (): LastPopularityFilter | null => {
	const result = localStorage.getItem(designItemPopularityFilterKey);
	return result === null ? null : JSON.parse(result);
};

export const getLastDesignItemSortPreference = (): SortOption => {
	const result = localStorage.getItem(designItemSortKey);
	return result === null ? "relevancy" : JSON.parse(result);
};